"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const SearchBar_1 = __importDefault(require("@episource/epi-storybook/lib/components/AppBar/SearchBar"));
const SearchButton_1 = __importDefault(require("@episource/epi-storybook/lib/components/AppBar/SearchButton"));
const lodash_1 = require("lodash");
const SearchResult_1 = __importDefault(require("../../components/TabView/SearchResult/SearchResult"));
const SearchBar = (0, material_1.styled)(SearchBar_1.default)({
    width: "360px",
});
const SearchContainer = (0, material_1.styled)(material_1.Popover)({});
const TopSearchBar = (0, material_1.styled)("div")(({ theme }) => ({
    width: "420px",
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(3),
}));
const GlobalSearch = ({ clientUrlPrefix, reset, search, results: { isFetching, error, members, providers }, anchor = null, }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(anchor);
    const [query, setQuery] = (0, react_1.useState)();
    const isSearchOpen = Boolean(anchorEl);
    const handleSearch = (s) => {
        setQuery(s);
        if (s)
            search(s);
    };
    const handleClose = () => {
        reset();
        setQuery("");
        setAnchorEl(null);
    };
    const debouncedSearch = (0, lodash_1.debounce)(handleSearch, 250);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SearchButton_1.default, { onSearchButtonClick: ({ currentTarget }) => setAnchorEl(currentTarget), isSearchVisible: isSearchOpen }),
        react_1.default.createElement(SearchContainer, { open: isSearchOpen, onClose: handleClose, anchorEl: anchorEl, anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left",
            } },
            react_1.default.createElement(TopSearchBar, null,
                react_1.default.createElement(SearchBar, { onSearch: handleSearch, onChange: debouncedSearch, label: "Keyword search", placeholder: "Search provider or member" })),
            react_1.default.createElement(SearchResult_1.default, { query: query, error: error, url: clientUrlPrefix, isFetching: isFetching, members: members, providers: providers, onSelect: handleClose }))));
};
exports.default = GlobalSearch;
